export interface CONFIG{
    api: {
      url: string
    },
    bubble: {
        apiKey: string
        baseUrl: {
            get:string
            post:string
        }
    },
    viettel:{
        token: string
        ekycURL: string
    },
    ga4:{
        trackingId: string
    },
    slack:{
        webhook: string
    },
    payOS:{
        endpoint:string,
        clientId:string,
        apiKey: string,
        checksumKey: string
    },
    finseyScore: {
        endpoint: string
        token: string
    }
}

export const config:CONFIG = {
    api: {
      url: process.env.NEXT_PUBLIC_API_URL  ?? ''
    },
    bubble: {
        apiKey: process.env.NEXT_PUBLIC_BUBBLE_API_KEY ?? '',
        baseUrl:{
            get: process.env.NEXT_PUBLIC_BUBBLE_URL ?? '',
            post: process.env.NEXT_PUBLIC_BUBBLE_URL ?? ''
        }
    },
    viettel:{
        token: process.env.NEXT_PUBLIC_VIETTEL_AI_TOKEN ?? '',
        ekycURL: process.env.NEXT_PUBLIC_VIETTEL_AI_EKYC_URL ?? ''
    },
    ga4:{
        trackingId: process.env.GA4_TRACKING_ID ?? ''
    },
    slack:{
        webhook: process.env.NEXT_PUBLIC_SLACK_WEBHOOK ?? ''
    },
    payOS:{
        endpoint:process.env.PAYOS_API_ENDPOINT ?? '',
        clientId:process.env.PAYOS_CLIENT_ID ?? '',
        apiKey: process.env.PAYOS_API_KEY ?? '',
        checksumKey: process.env.PAYOS_CHECKSUM_KEY ?? ''
    },
    finseyScore:{
        endpoint: process.env.NEXT_PUBLIC_FINSEY_SCORE_API_ENDPOINT ?? '',
        token: process.env.NEXT_PUBLIC_FINSEY_SCORE_API_TOKEN ?? ''
    }
}